import { PageTable, Header } from "/src/layouts/page";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import { useNavigate } from "react-router-dom";
import Table from "/src/components/table";
import "./RoleTable.css";
import RoleModal from "../RoleForm/RoleModal";
import RolePermissionModal from "../modal/rolePermissionModal/RolePermissionModal";
import imageChoices from "../RoleForm/roleImages";
import roleAdmin from "../../assets/role-superadmin.png";
import roleUser from "../../assets/role-partners.png";
import roleService from "../../services/roleService";
import storage from "/src/utils/storage";
import hasPermission from "/src/utils/hasPermission";
import { switchCompany } from "/src/utils/switchCompany";

function RoleTable({ bare = false }) {
    const currentUser = storage("local").get("user");
    const { getRoles, deleteRole, updateRole } = roleService;

    const navigate = useNavigate();

    const handleSwitch = async (id) => {
        await switchCompany(id, navigate);
    };

    const showImage = (logo, avatar, imageType, id) => {
        if (id === 1) {
            return <img src={roleAdmin} alt="Role Admin" />;
        } else if (id === 2) {
            return <img src={roleUser} alt="Role User" />;
        } else {
            const logoChoice = imageChoices.find((choice) => choice.value === logo);
            if (logoChoice && (imageType === "logo" || imageType === null)) {
                return <img src={logoChoice.text.props.src} alt={logoChoice.text.props.alt} />;
            } else if (avatar && (imageType === "avatar" || imageType === null)) {
                return <img src={avatar} width={24} height={24} alt={avatar} />;
            } else {
                return null;
            }
        }
    };

    var cells = [];
    if (currentUser.is_admin) {
        cells = [
            {
                column: "Badge",
                name: ["logo", "avatar", "last_updated_attribute", "id"],
                sort: false,
                show: ([logo, avatar, last_updated_attribute, id]) =>
                    showImage(logo, avatar, last_updated_attribute, id),
            },

            {
                column: "ROLENAME",
                name: "slug",
                sort: true,
                show: (value) => <div>{value == "admin" ? "Super Admin" : value}</div>,
            },

            {
                column: "Organizations",
                name: ["company.name", "company.id"],
                sort: {name : "company.name"},
                show: ([name, id]) => (
                    <a className="organization-link" onClick={() => handleSwitch(id)}>
                        {name}
                    </a>
                ),
            },

            {
                column: "DESCRIPTION",
                name: "name",
                show: (value) => <div>{value == "Administrator" ? "Super Administrator" : value}</div>,
            },
        ];
    } else {
        cells = [
            {
                column: "Badge",
                name: ["logo", "avatar", "last_updated_attribute"],
                sort: false,
                show: ([logo, avatar, last_updated_attribute]) => showImage(logo, avatar, last_updated_attribute),
            },

            {
                column: "ROLENAME",
                name: "slug",
                sort: true,
                show: (value) => value,
            },

            {
                column: "DESCRIPTION",
                name: "name",
                show: (value) => value,
            },
        ];
    }

    const showPermissionModal = async ({ row, updateRow }) => {
        await NiceModal.show(RolePermissionModal, {
            title: "List Permissions",
            role: row,
        }).then((role) => updateRow(role));
    };

    const onClickAdd = ({ addRow }) =>
        NiceModal.show(RoleModal, {
            title: "Create a new User",
        }).then((role) => addRow(role));

    const onClickUpdate = async ({ row, updateRow }) => {
        await NiceModal.show(RoleModal, {
            title: "Modify your Role",
            data: { ...row },
            type: "update",
        }).then((role) => updateRow(role));
    };

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, slug } = row;
        await ModalManager.show(ApiModal, {
            title: "Delete role " + slug,
            body: "Do you really want to delete this role " + slug,
            api: {
                request: deleteRole,
                param: [row.id],
            },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],

            confirm: {
                name: slug,
                fieldName: "the role",
            },
        }).then(() => deleteRow(id));
    };

    var actions = [];

    actions = [
        hasPermission("update_role")
            ? {
                  condition: "id",
                  condition_match: [1, 2],
                  ...(!currentUser.is_admin && {
                      other_condition: "create_by_admin",
                      other_match: currentUser.is_admin ? 0 : 1,
                  }),
                  className: "fas fa-cog action-button edit_action",
                  style: {},
                  onClick: onClickUpdate,
              }
            : null,
        hasPermission("update_role")
            ? {
                  condition: "id",
                  condition_match: [1, 2],
                  className: "fas fa-edit action-button profil_action",
                  style: {},
                  onClick: showPermissionModal,
              }
            : null,
        hasPermission("delete_role")
            ? {
                  condition: "id",
                  condition_match: [1, 2],
                  ...(!currentUser.is_admin && {
                      other_condition: "create_by_admin",
                      other_match: currentUser.is_admin ? 0 : 1,
                  }),
                  className: "fas fa-trash action-button delete_action",
                  style: {},
                  onClick: onClickDelete,
              }
            : null,
    ].filter((action) => action);

    const buttons = [hasPermission("create_role") ? { icon: "fas fa-plus", onClick: onClickAdd } : null].filter(
        (button) => button
    );

    const filters = [{ type: "input", placeholder: "content", name: "term" }];

    const getRolesCallable = async (params) => {
        if (currentUser.is_admin == false) {
            params = { ...params, company_id: currentUser.company.id };
        }
        return await getRoles(params);
    };

    const content = (
        <>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>

            <Table
                name="role"
                cells={cells}
                api={getRolesCallable}
                actions={actions}
                buttons={buttons}
                filters={filters}></Table>
        </>
    );

    if (bare) {
        return content;
    }

    return (
        <PageTable>
            <Header title="List of Roles"></Header>
            {content}
        </PageTable>
    );
}

export default RoleTable;
